/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:02:45
 */

import axios from 'axios';
// import NProgress from 'NProgress'
// import 'nprogress/nprogress.css'

// NProgress.inc(0.4)
// NProgress.configure({ easing: 'ease', speed: 600, showSpinner: false})

const BASE_API_URL = import.meta.env.VITE_BASE_URL
console.log(import.meta.env,'axios')

class Data {
    static getInstance() {
        if (!this.instance) this.instance = new Data()
        return this.instance
    }

    getData(url, params, method, dataType) {
        url = import.meta.env.MODE == 'development' ? url : `${BASE_API_URL}${url}`

        if (import.meta.env.MODE == 'production') {
            if (url.indexOf('/api') > -1){url = url.replace('/api', '')} 
        }

        if (method == 'GET' || method == 'get') {
            let urlParam = ''
            for (let key in params) {
                urlParam = urlParam == '' ? `?${key}=${encodeURIComponent(params[key])}` : `${urlParam}&${key}=${encodeURIComponent(params[key])}`
            }
            url = url + urlParam
        }
        // console.log(url,'url')

        let token = sessionStorage.getItem('token')
        let config = {
            headers: {
                'Content-Type': dataType? dataType : 'application/json;charset=utf-8',
                'Authorization': token == null? '' : 'Bearer ' + token,
                // 'Authorization': 'Bearer eyJ0eXBlIjoiSldUIiwiYWxnIjoiSFM1MTIifQ.eyJzdWIiOiLolKHms73mrKMiLCJyb2xlIjoiNCIsImdlbmRlciI6bnVsbCwib3JnIjowLCJ1c2VyX25hbWUiOiLolKHms73mrKMiLCJtb2JpbGUiOiIrODYxODgxNDM4MzM2NSIsImlkIjo4MTQsImV4cCI6MTc1NjE2OTYyMSwiaWF0IjoxNzQ4MjIwODIxLCJlbWFpbCI6ImNhaXpleGluQGtqZ2IubmV0IiwianRpIjoiNDA2MzcxMTA0NzI4MzM4NDMyIiwidGltZXN0YW1wIjoxNzQ0MTAyMjQ2fQ.iqL6b_ZyAbLHLgsZgTETNX8Qe8Hj1m90dYxLK_phA6SwQY5sdbXp8u3hL_P5OjJdCPnimx6X4HQeW4oxkA5qIQ',
            },
            method: method,
            timeout: 6 * 60 * 1000,
            url: url,
            data: params,
            responseType:'blob'
        }

        // NProgress.start();
        return new Promise((resolve, reject) => {
            axios(config).then(res => {
                if (res.data.code == 401) {

                } else {
                    if(res.data.type === 'application/json'){
                        let reader = new FileReader()
                        reader.readAsText(res.data,'utf-8')
                        reader.onload = ()=>{
                            let msg = JSON.parse(reader.result)
                            resolve(msg)
                        }
                    }else if(res.data.type === 'application/octet-stream'){
                        // console.log(res, 'res.data 导出')
                        resolve(res)
                    }
                }
            }).catch(error => {
                console.log(error, 'error')
                if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
                    resolve(error)
                }
                else if (error.response && error.response.data.type === 'application/json') {
                    let reader = new FileReader()
                    reader.readAsText(error.response.data, 'utf-8')
                    reader.onload = () => {
                        let msg = JSON.parse(reader.result)
                        resolve(msg)
                    }
                }
            })
        })
    }
}

export {
    Data
}